<template>
  <div
    class="section"
    :class="[skew === 'right' ? 'skew-right' : '', skew === 'left' ? 'skew-left' : '']"
    :id="id"
  >
    <div class="section-content px-3 md:px-5">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: ['skew', 'level', 'id'],
  data: function() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.section {
  @apply z-10 relative bg-grey-300 py-6 transform;
  .section-content {
    @apply relative max-w-5xl mx-auto transform;
  }
  &.transparent {
    background: transparent !important;
    h1,
    h2 {
      @apply text-grey-700;
    }
  }
  &.white {
    background: theme('colors.white');
  }
  &.astralblue {
    background: theme('colors.astralblue.500');
  }
  &.vividred {
    background: theme('colors.vividred.500');
  }
  &.skew-right {
    transform: skewY(2deg);
    @apply mt-12;
    .section-content {
      transform: skewY(-2deg);
    }
  }
  &.skew-left {
    transform: skewY(-2deg);
    @apply mt-12;
    .section-content {
      transform: skewY(2deg);
    }
  }
}
</style>
